import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { UiService } from '../../../../../core/services/core.ui.service';
import { TrackerService } from '../../../services/tracker.service';
import { TrackeritemService } from '../../../services/trackeritem.service';
import { ModalComponent } from '../../../../../core/config/core.modal-helpers';

@Component({
  selector: 'tracker-extra-field-edit',
  template: require('./tracker.extra.field.edit.modal.component.html')
})
export class TrackerExtraFieldEditComponent extends ModalComponent implements OnInit {
  @Input() field: any;
  @Input() fieldTypeMap: any;
  
  isLoading: boolean;
  title: string;
  fieldSet: number;
  fieldsOptions: any;
  defaultType: string;
  newElement: any;
  fieldType: string;
  defaultSelected: any;
  errors: any;
  showOnSubmit: boolean;
  showSpecialConfigPanel: boolean;

  constructor(
    private trackerService: TrackerService,
    private translateService: GfTranslateService,
    private uiService: UiService,
    private trackeritemService: TrackeritemService
  ) {
    super();
  }

  /**
   * Initializes the component, setting up initial values and configuration.
   */
  ngOnInit() {
    this.isLoading = true;

    if (this.field.id > 0) {
      this.title = this.field.alias;
      if (_.has(this.field, 'fieldName')) {
        this.title = this.field.fieldName + ' (' + this.field.alias + ')';
      }
    } else {
      const fieldTypeDesc = _.find(this.fieldTypeMap, { type: this.field.fieldType });
      this.fieldSet = new Date().getTime();
      this.title = 'Add ' + fieldTypeDesc.title + ' Field';
    }

    if (this.field.fieldType == 8) {
      this.field.fieldElements = this.trackerService.fields.getReleasesGroupedByStatus(this.field);
      this.fieldsOptions = {};
      this.fieldsOptions[this.field.alias] = {
        fieldElements: this.field.fieldElements
      };

      let defaultValue: any;
      try {
        defaultValue = parseInt(this.field.defaultValue);
      } catch (err) {
        defaultValue = 0;
      }

      this.defaultType = ['-1', '-2'].includes(this.field.defaultValue)
        ? this.field.defaultValue
        : defaultValue > 0
        ? '-3'
        : '-1';

      if (this.defaultType == '-3') {
        _.forEach(this.field.fieldElements, item => {
          if (this.field.defaultValue == item.id) {
            item.defaultSelected = true;
            this.field.fieldData = item;
          }
        });
      }
    } else if (this.field.fieldType == 10) {
      if (!Number.isInteger(this.field.attribute2) || !(_.toInteger(this.field.attribute2) > 0)) {
        this.field.attribute2 = '';
      }
    }

    this.newElement = this.field.alias == 'storyPoints' ? this.getNewSimpleElement() : this.getNewElement();
    this.fieldType = this.trackerService.fields.types.getDescription(this.field.fieldType);
    this.defaultSelected = {
      id: 0,
      label: 0
    };

    this.errors = {
      fieldName: {
        invalid: false,
        message: ''
      },
      alias: {
        invalid: false,
        message: ''
      },
      defaultValue: {
        invalid: false,
        message: ''
      },
      attribute1: {
        invalid: false,
        message: ''
      },
      attribute2: {
        invalid: false,
        message: ''
      },
      showError: false
    };

    // Convert statusIds to string
    _.forEach(this.field.fieldElements, element => {
      try {
        element.statusId = parseInt(element.statusId);
      } catch (err) {}
    });

    this.showOnSubmit = true;
    if (this.field.fieldType == 11) {
      this.showOnSubmit = false;
    }

    this.showSpecialConfigPanel = false;
    if (
      [1, 2, 3, 4, 5, 7, 6, 8, 10, 12, 14].includes(this.field.fieldType) &&
      (this.field.isExtraField || this.field.alias == 'storyPoints')
    ) {
      this.showSpecialConfigPanel = true;
    }

    if (this.field.fieldType == 8) {
      this.fieldsOptions = {};
      this.trackeritemService.setUnreleasedReleasesOnReleaseField(this.field)
        .then(() => {
          this.fieldsOptions = this.field.fieldElements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

    if (this.field.alias == 'storyPoints') {
      this.field.fieldElements = this.trackerService.fields.builtIn.story_points.getStoryPointsOptionsList(
        this.field.fieldElements,
        false
      );
    }

    // Init
    this.getDefaultSelected();
  }

  /**
   * Sets the default selected element.
   * @param element The element to set as default selected.
   */
  setDefaultSelected(element: any) {
    if (!element) {
      _.forEach(this.field.fieldElements, _element => {
        _element.defaultSelected = false;
      });
      this.defaultSelected.label = 0;
      return;
    }

    element.defaultSelected = true;
    this.defaultSelected.label = element.label;

    _.forEach(this.field.fieldElements, _element => {
      if (_element.label != element.label) {
        _element.defaultSelected = false;
      }
    });
  }

  /**
   * Sets the default selected simple element.
   * @param element The element to set as default selected.
   */
  setDefaultSelectedSimple(element: any) {
    this.field.defaultValue = _.get(element, 'id', 0);
  }

  /**
   * Saves the field configuration.
   * @param e The event object.
   */
  save(e: Event) {
    if (this.isEditableElementField() && !this.validateFieldElementsUniqueness()) {
      e.preventDefault();
      return;
    }

    if (this.field.fieldType == 8) {
      this.field.defaultValue = '';
      switch (this.defaultType) {
        case '-1':
          this.field.defaultValue = -1;
          break;
        case '-2':
          this.field.defaultValue = -2;
          _.forEach(this.field.fieldElements, item => {
            item.defaultSelected = false;
          });
          break;
        case '-3':
          if (!_.isEmpty(this.field.fieldData)) {
            _.forEach(this.field.fieldElements, item => {
              if (this.field.fieldData.id == item.id) {
                this.field.defaultValue = item.id;
              }
            });
          }
          break;
      }
    }

    if (!this.checkValidations(this.field)) {
      this.closeModal(this.field);
    } else {
      e.preventDefault();
    }
  }

  /**
   * Cancels the modal.
   */
  cancel() {
    this.closeModal();
  }

  /**
   * Checks if an element is valid.
   * @param element The element to validate.
   * @returns True if the element is valid, false otherwise.
   */
  isElementValid(element: any) {
    const label = _.trim(_.get(element, 'label', '')).toLowerCase();
    const alias = _.trim(_.get(element, 'alias', '')).toLowerCase();

    const isLabelUsed = _.some(this.field.fieldElements, _element => {
      return _.trim(_.get(_element, 'label', '')).toLowerCase() === label;
    });

    const isAliasUsed = _.some(this.field.fieldElements, _element => {
      return _.trim(_.get(_element, 'alias', '')).toLowerCase() === alias;
    });

    const isLabelValid = !isLabelUsed && label !== '';
    const isAliasValid = alias === '' || !isAliasUsed;

    return isLabelValid && isAliasValid;
  }

  /**
   * Adds a new element to the field.
   */
  addElement() {
    // Validate new element
    if (!this.validateNewElement()) {
      return;
    }

    // Get sort order for new element
    let sortOrder = 99999;
    const maxElementOrder = _.maxBy(this.field.fieldElements, (element: any) => element.sortOrder);

    if (!_.isEmpty(maxElementOrder)) {
      sortOrder = maxElementOrder.sortOrder + 1;
    }

    // Set sort order
    this.newElement.sortOrder = sortOrder;

    if (!Array.isArray(this.field.fieldElements)) {
      this.field.fieldElements = [];
    }

    this.newElement.statusId = parseInt(this.newElement.statusId);
    this.field.fieldElements.push(_.cloneDeep(this.newElement));

    setTimeout(this.scrollTable, 250);

    this.newElement = this.getNewElement();
  }

  /**
   * Adds a new simple element to the field.
   */
  addSimpleElement() {
    // Validate new element
    if (!this.validateNewNumericElement()) {
      return;
    }

    if (!Array.isArray(this.field.fieldElements)) {
      this.field.fieldElements = [];
    }

    try {
      this.newElement.id = parseInt(this.newElement.id);

      this.field.fieldElements.push(_.cloneDeep(this.newElement));

      setTimeout(this.scrollTable, 250);

      this.newElement = this.getNewSimpleElement();
    } catch (err) {
      this.uiService.message.showError(
        this.translateService.translate('The value {{id}} you entered must be an integer', this.newElement),
        this.translateService.translate('Add new value')
      );
    }
  }

  /**
   * Removes an element from the field.
   * @param index The index of the element to remove.
   */
  removeElement(index: number) {
    this.field.fieldElements.splice(index, 1);
  }

  /**
   * Moves an element up in the order.
   * @param index The index of the element to move.
   */
  moveUp(index: number) {
    if (index == 0) {
      return;
    }

    const elem1 = this.field.fieldElements[index - 1];
    this.field.fieldElements[index - 1] = this.field.fieldElements[index];
    this.field.fieldElements[index] = elem1;

    this.resetOrder();
  }

  /**
   * Moves an element down in the order.
   * @param index The index of the element to move.
   */
  moveDown(index: number) {
    if (index == this.field.fieldElements.length - 1) {
      return;
    }

    const elem1 = this.field.fieldElements[index + 1];
    this.field.fieldElements[index + 1] = this.field.fieldElements[index];
    this.field.fieldElements[index] = elem1;

    this.resetOrder();
  }

  /**
   * Moves an element to the bottom of the order.
   * @param index The index of the element to move.
   */
  moveBottom(index: number) {
    const elem1 = this.field.fieldElements[index];
    this.field.fieldElements = _.without(this.field.fieldElements, elem1).concat(elem1);

    this.resetOrder();
  }

  /**
   * Moves an element to the top of the order.
   * @param index The index of the element to move.
   */
  moveTop(index: number) {
    const elem1 = this.field.fieldElements[index];
    this.field.fieldElements = _.concat(elem1, _.without(this.field.fieldElements, elem1));

    this.resetOrder();
  }

  /**
   * Validates a new numeric element.
   * @returns True if the new numeric element is valid, false otherwise.
   */
  validateNewNumericElement() {
    if (typeof this.newElement.id !== 'number') {
      this.newElement.error = true;
      return false;
    } else {
      this.newElement.error = false;
      return true;
    }
  }

  /**
   * Validates a new element.
   * @returns True if the new element is valid, false otherwise.
   */
  validateNewElement() {
    if (this.newElement.alias == '' || this.newElement.label == '') {
      this.newElement.error = true;
      return false;
    } else if (!this.isElementValid(this.newElement)) {
      this.newElement.error = true;
      this.uiService.message.showError(
        this.translateService.translate('Element name and alias must be unique in this field.'),
        this.translateService.translate('Add new value')
      );
      return false;
    } else {
      this.newElement.error = false;
      return true;
    }
  }

  /**
   * Returns true when this field type uses editable elements.
   */
  private isEditableElementField() {
    return [1, 2, 3, 5, 7].includes(this.field.fieldType);
  }

  /**
   * Validates uniqueness of element labels and aliases in the current field.
   */
  private validateFieldElementsUniqueness() {
    const normalizedLabels = new Set<string>();
    const normalizedAliases = new Set<string>();

    for (const element of _.get(this.field, 'fieldElements', [])) {
      const rawLabel = _.get(element, 'label', '');
      const rawAlias = _.get(element, 'alias', '');
      const label = _.trim(rawLabel).toLowerCase();
      const alias = _.trim(rawAlias).toLowerCase();

      if (label === '') {
        this.uiService.message.showError(
          this.translateService.translate('Element name cannot be empty.'),
          this.translateService.translate('Edit Field')
        );
        return false;
      }

      if (normalizedLabels.has(label)) {
        this.uiService.message.showError(
          this.translateService.translate('Element names must be unique in this field.'),
          this.translateService.translate('Edit Field')
        );
        return false;
      }
      normalizedLabels.add(label);

      if (alias !== '') {
        if (normalizedAliases.has(alias)) {
          this.uiService.message.showError(
            this.translateService.translate('Element aliases must be unique in this field.'),
            this.translateService.translate('Edit Field')
          );
          return false;
        }
        normalizedAliases.add(alias);
      }
    }

    return true;
  }

  /**
   * Scrolls the table to the bottom.
   */
  private scrollTable() {
    const elementsList = document.getElementById('elementsList');
    if (elementsList) {
      elementsList.scrollTop = elementsList.scrollHeight;
    }
  }

  /**
   * Returns a new element with default values.
   * @returns A new element object.
   */
  private getNewElement() {
    return {
      label: '',
      alias: '',
      defaultSelected: false,
      sortOrder: 0,
      statusId: 1,
      toElements: []
    };
  }

  /**
   * Returns a new simple element with default values.
   * @returns A new simple element object.
   */
  private getNewSimpleElement() {
    return {
      id: '',
      label: ''
    };
  }

  /**
   * Resets the order of elements.
   */
  private resetOrder() {
    let i = 0;
    _.forEach(this.field.fieldElements, field => {
      field.sortOrder = i;
      i++;
    });
  }

  /**
   * Gets the default selected element.
   */
  private getDefaultSelected() {
    this.defaultSelected.label = 0;
    const el = _.find(this.field.fieldElements, { defaultSelected: true });

    if (el) {
      this.defaultSelected.label = el.label;
    }
  }

  /**
   * Checks validations for the field.
   * @param field The field to validate.
   * @returns True if there are validation errors, false otherwise.
   */
  protected checkValidations(field: any) {
    let errors = false;
    this.errors.fieldName.invalid = false;
    this.errors.alias.invalid = false;
    this.errors.defaultValue.invalid = false;
    this.errors.attribute1.invalid = false;
    this.errors.attribute2.invalid = false;

    if (field.fieldName.length === 0) {
      this.errors.fieldName.invalid = true;
      this.errors.fieldName.message = this.translateService.translate('Required Field');
      errors = true;
    } else if (field.fieldName.length < 1 || field.fieldName.length > 50) {
      this.errors.fieldName.invalid = true;
      this.errors.fieldName.message = this.translateService.translate(
        'Bad length. It should be between 5 and 999999 characters'
      );
      errors = true;
    }

    if (field.alias.length === 0) {
      this.errors.alias.invalid = true;
      this.errors.alias.message = this.translateService.translate('Required Field');
      errors = true;
    } else if (field.alias.length < 1 || field.alias.length > 50) {
      this.errors.alias.invalid = true;
      this.errors.alias.message = this.translateService.translate(
        'Bad length. It should be between 5 and 999999 characters'
      );
      errors = true;
    }

    if (field.alias == 'status' && field.fieldType != 7) {
      this.errors.alias.invalid = true;
      this.errors.alias.message = this.translateService.translate(
        'Alias "status" is reserved for the status field, please choose a different alias'
      );
      errors = true;
    }

    if (field.fieldType == 8) {
      if (this.field.attribute2 == '1' && !['-1', '-2'].includes(this.field.defaultValue.toString())) {
        // Validate that there's a default Value selected
        let defaultSelected = 0;
        try {
          defaultSelected = parseInt(this.field.defaultValue);
        } catch (err) {}

        if (!(defaultSelected > 0)) {
          this.errors.defaultValue.invalid = true;
          this.errors.defaultValue.message = this.translateService.translate('You need to select a default release.');
          errors = true;
        }
      }
    } else if (field.fieldType == 10) {
      const attribute2 = _.toInteger(this.field.attribute2);

      if (!_.isEmpty(this.field.attribute2) && (!Number.isInteger(attribute2) || !(attribute2 > 0))) {
        this.errors.attribute2.invalid = true;
        this.errors.attribute2.message = this.translateService.translate(
          'The number of digits must be an integer greater than zero.'
        );
        errors = true;
      }

      if (!_.isEmpty(this.field.defaultValue) && Number.isNaN(_.toNumber(this.field.defaultValue.replace(',', '')))) {
        this.errors.defaultValue.invalid = true;
        this.errors.defaultValue.message = this.translateService.translate(
          'The default value must be a numeric value of, at most, {{num_digits}} digits.',
          { num_digits: this.field.attribute2 }
        );
        errors = true;
      } else if (
        !Number.isNaN(_.toNumber(this.field.defaultValue.replace(',', ''))) &&
        _.toInteger(this.field.attribute2) > 0 &&
        this.field.defaultValue.length > _.toInteger(this.field.attribute2)
      ) {
        this.errors.defaultValue.invalid = true;
        this.errors.defaultValue.message = this.translateService.translate(
          'The default value must be of, at most, {{num_digits}} digits.',
          { num_digits: this.field.attribute2 }
        );
        errors = true;
      }
    }
    return errors;
  }

  /**
   * Changes the enabled setting of the field.
   * @param field The field to change the setting for.
   */
  settingIsEnabledChanged(field: any) {
    if (!field['isEnabled']) {
      field['isRequired'] = false;
      field['showOnSubmit'] = false;
    }
  }

  /**
   * Changes the required setting of the field.
   * @param field The field to change the setting for.
   */
  settingIsRequiredChanged(field: any) {
    if (field['isRequired']) {
      field['isEnabled'] = true;
      field['showOnSubmit'] = true;
    }
  }

  /**
   * Changes the show on submit setting of the field.
   * @param field The field to change the setting for.
   */
  settingShowOnSubmitChanged(field: any) {
    if (field['showOnSubmit']) {
      field['isEnabled'] = true;
    }
  }
}
